const BaseView = require('../templates-base');
const FormatFactory = require('../../../../factory/formats');
const CompanyFactory = require('../../../../factory/company').instance;
const rf = require('../../../../facade/restrictions/restrictions');
const TemplatePageThumbnailView = require('../../components/thumbnail/template-page');
const BrandTemplateThumbnailView = require('../../components/thumbnail/restricted');

module.exports = BaseView.extend({
  fetchType: 'brand',
  initialize: function () { },
  columnWidth: 255,

  show: function () {
    if (!this.$el.find('.thumbnail-wrapper li').length && !this.loaded) {
      this.loaded = true;
      this.tool = INKIVE.Tool.getInstance();
      this.canvas = this.tool.editor.canvas;

      return FormatFactory.getCurrentFormat().then(_.bind(function (format) {
        this.format = format;
        BaseView.prototype.initialize.call(this, { format });
      }, this));
    }
  },

  loadData: function (repeat, end) {
    this.end = end;
    this.repeat = repeat;

    return this.getDesign()
      .then(this.getTemplateData.bind(this))
      .then(this.onMoreData.bind(this));
  },

  getMatchingTemplates: async function () {
    const formats = await FormatFactory.getFormats();
    const matchingFormats = formats.filter(format => this.formatMatchesCanvas(format));
    const matchingTemplates = await Promise.all(matchingFormats.map(format =>
      FormatFactory.getFormatTemplates(format)
    ));

    return matchingTemplates.reduce((result, templates, index) => {
      return result.concat(templates
        .filter(template => !template.is_draft)
      );
    }, []);
  },

  getDesign: function () {
    return new Promise(resolve => {
      return CompanyFactory.get(['designs', INKIVE.C.BOOK.encodedId])
        .then(design => resolve(design));
    });
  },

  getTemplate: async function (design) {
    if (!design.template) return;

    return await CompanyFactory.get(['templates', design.template]);
  },

  getTemplateData: async function (design) {
    const matchedTemplates = await this.getMatchingTemplates();
    if (matchedTemplates.length) return { formats: matchedTemplates };

    const templates = await this.getTemplate(design);
    return { templateData: templates?.pages || [] };
  },

  onMoreData: async function (data) {
    this.$scrollDetect = this.$el.find('.thumbnail-wrapper .scrollDetect');
    this.canChangePageOrder = rf.isFunctionalityAllowed('function_change_page_order');

    const { formats, templateData } = data;

    if (formats?.length) {
      formats.forEach(template => {
        this.appendTemplateThumbnail(this.format, template);
      });
    } else if (templateData?.pages?.length) {
      templateData.pages.forEach((template, index) => {
        this.appendTemplatePageThumbnails(this.format, templateData, index);
      });
    } else {
      this.renderEmptyResults();
    }

    this.end();

    INKIVE.Helpers.initTooltips(this.$el);
    INKIVE.Modal.loaderClose(this.$el.find('.antiscroll-inner'));
    this.scrollRefresh();
  },

  renderEmptyResults: function () {
    const nothingToShow = INKIVE.TranslateHelper.translate('tool.templates.no_similar_formats');
    this.$el.prepend(`<div class="no-templates">${nothingToShow}</div>`);
  },

  appendTemplatePageThumbnails: function (format, template, pageNumber) {
    const $thumbnailView = $('<li>').addClass('thumbnail image loading').insertBefore(this.$scrollDetect);

    new TemplatePageThumbnailView({
      el: $thumbnailView,
      width: this.columnWidth,
      format,
      template,
      pageNumber: parseInt(pageNumber),
      canChangePageOrder: this.canChangePageOrder
    });
  },

  appendTemplateThumbnail: function (format, template) {
    const $thumbnailView = $('<li>').addClass('thumbnail image loading').insertBefore(this.$scrollDetect);

    new BrandTemplateThumbnailView({
      el: $thumbnailView,
      width: this.columnWidth,
      format,
      baseTemplate: template
    });
  }
});
